import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, ArrowLeft, MessageSquare } from "lucide-react";
import RudrasLogo from "../components/RudrasLogo";

/**
 * Friendly 404 — used as the catch-all route in App.js. Keeps the brand alive
 * and gives the user three obvious ways forward (home, public demo, sign-in).
 */
export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 py-12 bg-gradient-to-br from-emerald-50 via-white to-amber-50/40 text-center" data-testid="not-found-page">
      <Link to="/" className="inline-flex items-center gap-2.5 group mb-10" data-testid="not-found-brand">
        <RudrasLogo size="xl" ringed className="ring-amber-300/30" />
        <span className="font-display font-semibold text-2xl tracking-tight text-emerald-950">Rudras-AI</span>
      </Link>

      <div className="font-mono text-[11px] tracking-[0.3em] uppercase text-emerald-700/80 mb-3">Error · 404</div>
      <h1 className="font-display text-4xl sm:text-5xl font-semibold text-slate-900 mb-3 max-w-xl">
        This page didn't load.
      </h1>
      <p className="text-slate-600 max-w-md mb-9 leading-relaxed">
        The link may be broken, or the page may have moved. Sara can help — or just head
        back home and we'll get you where you were going.
      </p>

      <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-2.5 rounded-lg bg-emerald-900 hover:bg-emerald-950 text-white text-sm font-medium shadow-md transition"
          data-testid="not-found-home"
        >
          <ArrowLeft className="w-4 h-4" /> Back to home
        </Link>
        <Link
          to="/chat/rudras-healthcare-demo"
          className="inline-flex items-center gap-2 px-6 py-2.5 rounded-lg bg-white border border-emerald-200 hover:border-emerald-400 text-emerald-900 text-sm font-medium transition"
          data-testid="not-found-try-demo"
        >
          <MessageSquare className="w-4 h-4" /> Try the live demo
        </Link>
        <Link
          to="/login"
          className="inline-flex items-center gap-2 px-6 py-2.5 rounded-lg text-emerald-900 hover:text-emerald-950 text-sm font-medium transition underline-offset-4 hover:underline"
          data-testid="not-found-login"
        >
          Sign in →
        </Link>
      </div>

      <div className="mt-14 pt-6 border-t border-emerald-200/60 text-[11px] text-slate-500">
        © 2026 Rudras-AI · Built on the Intelligence Layer
      </div>
    </div>
  );
}
